import React , {Component} from 'react';
import {
    SkeletonBlock
} from 'framework7-react';

class TrackingLoader extends Component{
    render(){
        return(
            <div id="tracking-loading" className="h-100 bg-white overflow-x-scroll">

                <div style={{height:"20px" , opacity:"0"}} />
                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>



                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>

                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>

                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>

                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>

                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>

                <div className="order-card-loading">
                    <div className="title">
                        <SkeletonBlock slot="media" effect={"blink"} className="skeleton-effect-blink"/>
                    </div>
                </div>


            </div>
        )
    }
}

export default TrackingLoader;